import { StoreState } from '../../reducers';
import { connect } from 'react-redux';
import NoSaveAsPopup from '../../components/NoSaveAsPopup';

const mapStateToProps = (state: StoreState) => {
	const { noSaveAsPopup: {isDisplayed} } = state;
	return { isDisplayed };
};

export default connect(mapStateToProps)(NoSaveAsPopup);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/NoSaveAsPopup/index.tsx